import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';

@Component({
  standalone: true,
  selector: 'app-layout',
  imports: [NavbarComponent, RouterOutlet, FooterComponent],
  templateUrl: './layout.component.html'
})
export class LayoutComponent {}